import { Box, Button, Stack, Typography, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import EditOnly from "../permissions/EditOnly";

const BottomBar = styled(Box)(() => ({
  padding: "14px 28px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderTop: "1px solid rgba(0,0,0,0.06)",
  backgroundColor: "#fff",
  flexShrink: 0,
}));

const buttonSx = {
  borderRadius: 2,
  height: 42,
  px: 2.5,
  fontWeight: 700,
  fontSize: 14,
};

interface RouteBottomBarProps {
  mode: "create" | "edit";
  localsCount: number;
  isSubmitDisabled: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

const RouteBottomBar = ({
  mode,
  localsCount,
  isSubmitDisabled,
  onCancel,
  onSubmit,
}: RouteBottomBarProps) => {
  const { t } = useTranslation();

  return (
    <BottomBar>
      <Stack direction="row" spacing={3} alignItems="baseline">
        <Box>
          <Typography sx={{ fontSize: 10, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: 0.5 }}>
            {t("table.local.locals")}
          </Typography>
          <Typography color={"primary"} sx={{ fontSize: 18, fontWeight: 900 }}>{localsCount}</Typography>
        </Box>
      </Stack>

      <Stack direction="row" spacing={1.5}>
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={{
            ...buttonSx,
            borderColor: "rgba(0,0,0,0.18)",
            color: "text.secondary",
          }}
        >
          {t("header.cancel")}
        </Button>

        <EditOnly>
          <Button
            variant="contained"
            color="primary"
            disabled={isSubmitDisabled}
            onClick={onSubmit}
            sx={buttonSx}
          >
            {mode === "create"
              ? (t("table.route.create"))
              : (t("table.route.edit"))}
          </Button>
        </EditOnly>
      </Stack>
    </BottomBar>
  );
};

export default RouteBottomBar;